<template>
  <nuxt-link :to="look.route" class="block my-24 h-full">
    <SimpleSwiper :images="slides" />

    <div class="flex flex-wrap justify-start mt-12">
      <div
        v-for="product in look.products"
        :key="product.id"
        class="
          w-56
          h-64
          rounded-regular
          bg-black-25
          mr-12
          p-6
          flex
          justify-center
        "
      >
        <nuxt-img
          :src="product.image_url"
          sizes="mob414:44px desk:44px"
          :alt="product.title"
          class="rounded-regular max-h-full max-w-full"
        />
      </div>
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
import { type LooksData } from '~/constants/types/page';
import SimpleSwiper from '~/components/global/SimpleSwiper.vue';

const props = defineProps<{
  look: LooksData,
}>();

const slides = computed(()=> {
  return props.look.images.map(m => m.url);
});

</script>

<style scoped lang="postcss">

</style>
